var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15,
    r: 15,
    fill: "#121622"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0071 12.7585V12.6685C13.0071 12.2545 13.0431 11.6605 13.4931 11.1925C13.9431 10.7245 14.7531 10.5445 15.4551 10.5445C16.0491 10.5445 16.6791 10.6705 17.0931 10.9045C17.6691 11.2465 17.8311 11.7325 17.8311 12.1465C17.8311 12.5605 17.6871 12.9025 17.3631 13.2265C17.1471 13.4245 16.5891 13.8205 16.4271 13.9285L15.8691 14.3065C15.4911 14.5585 15.0411 14.9185 14.7171 15.3865C14.2491 16.0705 14.2131 16.6645 14.2131 17.3485V17.5465H16.4631V17.3305C16.4631 16.7365 16.7151 16.2685 17.0931 15.9085C17.3451 15.6745 18.1191 15.1705 18.4791 14.9545L19.1451 14.5585C20.5491 13.7305 20.6391 12.5245 20.6391 12.0025C20.6391 10.6525 19.9551 9.82445 19.1451 9.32045C18.4251 8.87045 17.3451 8.56445 15.6351 8.56445C13.6911 8.56445 12.5571 8.96045 11.8551 9.46445C10.4691 10.4545 10.3611 11.8765 10.3611 12.6145V12.7585H13.0071ZM13.9071 21.4345H16.7151V19.0765H13.9071V21.4345Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.aae82321eb58991aae80cfd7900e455b.svg";
export { ForwardRef as ReactComponent };